export default "__VITE_PUBLIC_ASSET__5733225b__"